import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

// actions
import { doneIndicator, error } from '../actions/standardActions';

// api
import passwordResetAPI from '../sources/api/passwordResetAPI';

// constants
import { PASSWORD_RESET_CREATE, PASSWORD_RESET_UPDATE } from '../constants/passwordResetTypes';

// lib
import httpSaga from '../lib/httpSaga';

export function* passwordResetCreate(action) {
  if (action['@@redux-saga/SAGA_ACTION']) return;

  const payload = action.payload;

  try {
    yield* httpSaga(PASSWORD_RESET_CREATE, call(passwordResetAPI.create, payload));
  } catch (err) {
    yield put(error(PASSWORD_RESET_CREATE, err));
  } finally {
    yield put(doneIndicator(PASSWORD_RESET_CREATE));
  }
}

export function* passwordResetUpdate(action) {
  if (action['@@redux-saga/SAGA_ACTION']) return;

  const payload = action.payload;

  try {
    yield* httpSaga(PASSWORD_RESET_UPDATE, call(passwordResetAPI.update, payload));
  } catch (err) {
    yield put(error(PASSWORD_RESET_UPDATE, err));
  } finally {
    yield put(doneIndicator(PASSWORD_RESET_UPDATE));
  }
}

export function* watchPasswordResetCreate() {
  yield takeEvery(PASSWORD_RESET_CREATE, passwordResetCreate);
}

export function* watchPasswordResetUpdate() {
  yield takeEvery(PASSWORD_RESET_UPDATE, passwordResetUpdate);
}

export default function* root() {
  yield all([
    fork(watchPasswordResetCreate),
    fork(watchPasswordResetUpdate)
  ]);
}



// WEBPACK FOOTER //
// ./app/sagas/passwordReset.js